import React, { useState } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import LoginPage from './authentication/pages/LoginPage';
import { Box, CssBaseline, Paper, ThemeProvider } from '@mui/material';
import lightTheme from './theme';
import { useSelector } from 'react-redux';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import { selectUser } from './api/auth/authSlice';
import Loader from './components/Loader';
import AdminRoutes from './routes/AdminRoutes';
import { ResalePartnerRoutes } from './routes/ResalePartnerRoutes';
import { EmbeddedPartnerRoutes } from './routes/EmbeddedPartnerRoutes';

const App = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  let user = useSelector(selectUser);
  const [openSidebar, setOpenSidebar] = useState(true);

  return (
    <ThemeProvider theme={lightTheme}>
      <Router>
        <Box sx={{ display: 'flex', minHeight: '100vh' }}>
          <CssBaseline />
          {isAuthenticated && (
            <>
              <Header toggleSidebar={() => setOpenSidebar(!openSidebar)} />
              <Sidebar openSidebar={openSidebar} toggleSidebar={() => setOpenSidebar(!openSidebar)} />
            </>
          )}
          <Paper
            component="main"
            sx={{
              flexGrow: 1,
              padding: { xs: 2, md: 3 },
              marginLeft: { xs: 0, sm: 0, md: '240px' },
              marginTop: '4vh',
              overflowY: 'scroll',
              maxHeight: '93vh',
            }}
          >
            <Routes>
              {/* Public Route */}
              <Route path="/login" element={<LoginPage />} />
              {user && Object.keys(user).length > 0 ? (
                <>
                  {user.role === 'admin' && AdminRoutes()}
                  {user.role === 'partner' && !user.is_embedded && ResalePartnerRoutes()}
                  {user.role === 'partner' && user.is_embedded && EmbeddedPartnerRoutes()}

                  {/* Redirect to default page based on user */}
                  {user.role === 'admin' && <Route path="*" element={<Navigate to="/subscriptions" />} />}
                  {user.role === 'partner' && !user.is_embedded && (
                    <Route path="*" element={<Navigate to="/subscriptions" />} />
                  )}
                  {user.role === 'partner' && user.is_embedded && (
                    <Route path="*" element={<Navigate to="/dashboard" />} />
                  )}
                </>
              ) : (
                // Redirect all routes to login if not authenticated
                <Route path="*" element={<Navigate to="/login" replace />} />
              )}
            </Routes>
          </Paper>
          <Loader />
        </Box>
      </Router>
    </ThemeProvider>
  );
};

export default App;
